import {UserConfig} from "../../types/UserConfig";
import Crisp from "./crisp";

export class CrispService {

    public static id = "crispService";

    /** @ngInject */
    public constructor(private userConfig: UserConfig) {
    }

    public startCrisp() {
        if (this.userConfig.branding === "IV") {

            (window as any).$crisp=[];
            (window as any).CRISP_WEBSITE_ID="c0c495bb-5038-4ff1-b30e-0d1db589e046";
            (window as any).$crisp.push(["set", "user:email", this.userConfig.username]);
            (window as any).$crisp.push(["set", "user:phone", this.userConfig.profile.phone]);
            (window as any).$crisp.push(["set", "user:nickname", this.userConfig.shortName]);

            Crisp();
        }
    }
}
